import React, { ReactElement } from 'react';
import { Helmet } from 'react-helmet-async';
import { getWindow } from 'src/utilities/window';

interface IDatadogRumScriptProps {
  monitorDetails: {
    clientToken: string;
    applicationId: string;
    env: string;
  };
}

export const DatadogRumScript = ({
  monitorDetails,
}: IDatadogRumScriptProps): ReactElement => {
  const window = getWindow();

  return (
    <Helmet defer={false}>
      {/* Currently using datadog real user monitoring. */}
      {/* Don't attempt to initialize twice */}
      {!window.DD_RUM && (
        <script type="text/javascript">
          {`
            (function(h,o,u,n,d) {
              h=h[d]=h[d]||{q:[],onReady:function(c){h.q.push(c)}}
              d=o.createElement(u);d.async=1;d.src=n
              n=o.getElementsByTagName(u)[0];n.parentNode.insertBefore(d,n)
            })(window,document,'script','https://www.datadoghq-browser-agent.com/us1/v5/datadog-rum.js','DD_RUM')
            window.DD_RUM.onReady(function() {
              window.DD_RUM.init({
                clientToken: '${monitorDetails.clientToken}',
                applicationId: '${monitorDetails.applicationId}',
                // site refers to the Datadog site parameter of your organization
                // see https://docs.datadoghq.com/getting_started/site/
                site: 'datadoghq.com',
                service:'corporate-management',
                env: '${monitorDetails.env}',
                // Specify a version number to identify the deployed version of your application in Datadog
                version: '${process.env.PROJECT_VERSION}',
                sessionSampleRate: 100,
                sessionReplaySampleRate: 0,
                trackUserInteractions: true,
                trackResources: true,
                trackLongTasks: true,
                defaultPrivacyLevel: 'mask',
              });
            })
          `}
        </script>
      )}
    </Helmet>
  );
};
